document.addEventListener("DOMContentLoaded", function () {
  // Highlight the "unlocked" pricing tier for bulk buying

  //   PDP quantity selector
  const quantityInput = document.querySelector(
    ".product-details .quantity__input"
  );
  if (!quantityInput) return;

  // Get product category from a data attribute on the picker
  const picker = document.querySelector(".label-bulk-order");
  let productCategory = picker?.getAttribute("data-product-category");
  let productPack = picker?.getAttribute("data-product-pack");

  // Define tiers for each category, so we know what numbers to listen for
  const tiers = {
    "Fragrance Oils": [2, 6, 12, 24],
    Wax: [6, 12, 24, null],
    "Wicks & Reeds": [5, 10, 15, 20],
    "Loose Goods": [60, 120, 240, 480],
  };

  if (productCategory === "Pre-Packed Goods") {
    if (productPack === "Pack of 6") {
      tiers["Pre-Packed Goods"] = [10, 20, 30, 40];
    } else if (productPack === "Pack of 3") {
      tiers["Pre-Packed Goods"] = [20, 40, 80, 160];
    } else {
      tiers["Pre-Packed Goods"] = [30, 60, 120, 240];
    }
  }

  console.log("Tiers: ", tiers);

  function getTier(quantity, category) {
    const t = tiers[category] || [];
    if (!t.length) return null;
    // Tier 4
    if (t[3] && quantity >= t[3]) return 4;
    // Tier 3
    if (t[2] && quantity >= t[2]) return 3;
    // Tier 2
    if (t[1] && quantity >= t[1]) return 2;
    // Tier 1
    if (t[0] && quantity >= t[0]) return 1;
    // Tier 0: 1 up to (tier_1_quantity - 1)
    if (t[0] && quantity >= 1 && quantity < t[0]) return 0;
    return null;
  }

  //   Update on quantity change
  function updateUnlockedLabel() {
    const quantity = parseInt(quantityInput.value, 10);
    if (isNaN(quantity)) return;
    const tier = getTier(quantity, productCategory);

    // Remove unlocked class from all
    document.querySelectorAll(".label--wrapper").forEach((el) => {
      el.classList.remove("label-unlocked-price");
    });

    // Only add unlocked class to the label for the selected variant and correct tier
    const checkedRadio = document.querySelector(".variant-radio:checked");
    if (tier !== null && checkedRadio) {
      // Find the closest .field for the checked radio
      const field = checkedRadio.closest(".field");
      if (field) {
        // Find the label--wrapper for this field and tier
        const label = field.querySelector(".label--wrapper-tier-" + tier);
        if (label) label.classList.add("label-unlocked-price");
      }
    }
  }

  console.log(quantityInput);
  quantityInput.addEventListener("input", function () {
    updateUnlockedLabel(true);
  });
  quantityInput.addEventListener("change", function () {
    updateUnlockedLabel(true);
  });

  // Also update when a variant is selected
  document.querySelectorAll(".variant-radio").forEach((radio) => {
    radio.addEventListener("change", function () {
      updateUnlockedLabel(true);
    });
  });

  updateUnlockedLabel(false);
});
